import {DragButton, Types} from "./DragButton";
import {Button, Select} from "@amzn/awsui-components-react";
import React from "react";
import {DropTarget} from "react-dnd";
import {
  AGGREGATE_TYPE,
  ALL_CONST_DETAILS,
  FILTER_TYPE, JOIN_TYPE,
  newCalcDetailFromType,
  OPERATION_TYPE, ROUND_TYPE, SAVE_TRANSFORM_TYPE,
  SOURCE_TYPE, SPECIAL_VT_TRUE_UP
} from "../CalcDetails";
import {SourceCard} from "./SourceCard";
import {FilterCard} from "./FilterCard";
import {AggregateCard} from "./AggregateCard";
import {OperationCard} from "./OperationCard";
import {RoundCard} from "./RoundCard";
import {JoinCard} from "./JoinCard";
import {SpecialVTTrueUpCard} from "./SpecialVTTrueUpCard";


class StepCard extends React.Component {

  constructor(props) {
    super(props);
  }


  render() {
    const options = ALL_CONST_DETAILS.map((x, ind) => {
      return {label: x, id: ind}
    });
    const optionsToId = ALL_CONST_DETAILS.reduce((obj, val) => {
      obj[val] = ALL_CONST_DETAILS.indexOf(val);
      return obj;
    }, {})
    const calcTypeChange = (e, item) => {
      let newItem = newCalcDetailFromType(e.detail.selectedOption.label, item.guid);
      this.props.cardStateReplacer(this.props.data.indexOf(item), newItem);
    };
    const item = this.props.item;

    const sourceCalcs = this.props.data.filter(x => x.calc_type === SOURCE_TYPE);
    // Columns is a list of two element lists with the first as the display and the second as the value
    let columns = [].concat.apply([], sourceCalcs.map(x => {
      const matches = this.props.columnMetadata.filter(y => y.jobName === x.source);
      if (matches.length > 0) {
        return matches[0].columns.map(y => {
          const val = `${x.alias}.${y}`;
          return sourceCalcs.length > 1 ? [val, val] : [y, val]
        });
      }
      return [];
    }));

    // Get all previous operation results
    const operationResults = this.props.data.filter(x => this.props.data.indexOf(x) <
      this.props.data.indexOf(item) && x.calc_type === OPERATION_TYPE).map(x => {
      const val = `${x.output_table}.${x.output_column}`;
      return sourceCalcs.length > 1 ? [val, val] : [x.output_column, val]
    });
    let joinResults = [];
    let filtered = this.props.data.filter(x => this.props.data.indexOf(x) < this.props.data.indexOf(item) && x.calc_type === JOIN_TYPE);
    for (let x of filtered) {
      if (x.column0 === undefined || x.column1 === undefined) {
        continue;
      }
      let allresults = columns.concat(operationResults).concat(joinResults);
      const column0Source = x.column0.split(".")[0];
      const column1Source = x.column1.split(".")[0];
      const source_name = `${column0Source}_X_${column1Source}`;

      // Get all previous results that involve any of the things that have been joined
      allresults = allresults.filter(y => y[1].split(".")[0] === column0Source || y[1].split(".")[0] === column1Source);
      const ret = allresults.map(y => {
        const columnName = y[1].split(".");
        const val = `${source_name}.${columnName[0] === column0Source ? column0Source : column1Source}_${columnName[1]}`;
        return [val, val];
      });
      joinResults.push(...ret);
    }

    columns = columns.concat(operationResults).concat(joinResults);

    const contentFunction = (item) => {
      const replacer = (data) => this.props.cardStateReplacer(this.props.data.indexOf(item), data);
      let possibleTables = columns.map(x => x[1].split(".")[0]);
      possibleTables = [...new Set(possibleTables)];
      const allSources = this.props.data.filter(x => x.calc_type === SOURCE_TYPE);
      if (item.calc_type === SOURCE_TYPE) {
        return <SourceCard data={item}
                           sources={this.props.columnMetadata}
                           onChange={replacer}
                           disabled={this.props.controlDisabled}
                           alias={item.alias}
                           allSources={allSources}/>;
      } else if (item.calc_type === FILTER_TYPE) {
        return <FilterCard data={item}
                           columns={columns}
                           onChange={replacer}
                           disabled={this.props.controlDisabled}/>;
      } else if (item.calc_type === AGGREGATE_TYPE) {
        return <AggregateCard data={item}
                              columns={columns}
                              onChange={replacer}
                              disabled={this.props.controlDisabled}/>;
      } else if (item.calc_type === OPERATION_TYPE) {
        return <OperationCard data={item}
                              results={columns}
                              sources={possibleTables}
                              onChange={replacer}
                              disabled={this.props.controlDisabled}/>;
      } else if (item.calc_type === SAVE_TRANSFORM_TYPE) {
        return <div style={{marginTop: "25px"}}>Save Transformed File</div>;
      } else if (item.calc_type === ROUND_TYPE) {
        return <RoundCard data={item}
                          columns={columns}
                          onChange={replacer}
                          disabled={this.props.controlDisabled}/>;
      } else if (item.calc_type === JOIN_TYPE) {
        return <JoinCard data={item}
                         columns={columns}
                         onChange={replacer}
                         disabled={this.props.controlDisabled}/>
      } else if (item.calc_type === SPECIAL_VT_TRUE_UP) {
        return <SpecialVTTrueUpCard data={item}
                                    sources={possibleTables}
                                    onChange={replacer}
                                    disabled={this.props.controlDisabled}/>
      } else {
        return "Unrecognized Type"
      }
    };
    const backgroundStyle = {};
    if (this.props.connectCanDrop) {
      if (this.props.connectIsOver) {
        backgroundStyle.backgroundColor = 'lightgreen';
      } else {
        backgroundStyle.backgroundColor = 'lightyellow';
      }
    }
    let clearButton = "";
    let selectBox = "";
    let dragButton = "";
    if (item.calc_type !== SAVE_TRANSFORM_TYPE && item.calc_type !== ROUND_TYPE && item.calc_type !== SPECIAL_VT_TRUE_UP) {
      clearButton =
        <div style={{width: "25px"}}>
          <div style={{marginTop: "20px"}}>
            <Button variant="icon"
                    icon="close"
                    onClick={() => this.props.cardStateRemover(this.props.data.indexOf(item))}
                    disabled={this.props.controlDisabled}/>
          </div>
        </div>

      selectBox =
        <div style={{'paddingRight': '2rem', flexGrow: 10}}>
          Type:<Select options={options}
                       selectedOption={{
                         label: item.calc_type,
                         id: optionsToId[item.calc_type]
                       }}
                       onChange={(e) => calcTypeChange(e, item)}
                       selectedLabel="Selected"
                       disabled={this.props.controlDisabled}/>
        </div>;
    }
    if (item.calc_type !== SOURCE_TYPE && item.calc_type !== ROUND_TYPE) {
      dragButton = <DragButton data={this.props.data.indexOf(item)}
                               onChange={this.props.cardRearranger}/>;
    }

    return this.props.connectDropTarget(
      <div className={"awsui-util-container"} style={backgroundStyle}>
        <div className={"awsui-util-container-header"} style={backgroundStyle}>
          <h2>{`Step ${this.props.data.indexOf(item) + 1}: ${item.calc_type}`}</h2>
        </div>
        <div style={{display: "flex", flexWrap: true}}>
          <div style={{width: "35px"}}>
            <div style={{marginTop: "20px"}}>
              {dragButton}
            </div>
          </div>
          {selectBox}
          <div style={{flexGrow: 85}}>
            {contentFunction(item)}
          </div>
          {clearButton}
        </div>
      </div>
    );
  }
}

const dropSpec = {
  drop(props, monitor, component) {
    return {data: props.data.indexOf(props.item)};
  },
  canDrop(props, monitor) {
    return !props.controlDisabled && props.item.calc_type !== ROUND_TYPE && props.item.calc_type !== SOURCE_TYPE;
  }
};

const dropCollect = function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    connectIsOver: monitor.isOver(),
    connectCanDrop: monitor.canDrop()
  };
}

const ex = DropTarget(Types.CARD, dropSpec, dropCollect)(StepCard);
export {ex as StepCard};